import React from "react";
import "./SuccessModal.css";
import { FiCheckCircle } from "react-icons/fi";

const SuccessModal = ({ message, onClose }) => {
  return (
    <div className="success-modal-overlay">
      <div className="success-modal">
        <div className="success-modal-header">
          <div className="logo-container">
            <span className="logo-text">I2M</span>
          </div>
        </div>
        <div className="success-modal-content">
          <div className="success-icon">
            <FiCheckCircle />
          </div>
          <p className="success-message">{message}</p>
        </div>
        <div className="success-modal-footer">
          <button className="confirm-button" onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
